module.exports = __webpack_public_path__ + "img/icon_online_p.d4b82a59.png";